module.exports = __webpack_public_path__ + "img/slider_galery_4.9c22418c.jpg";